import { axios } from "../Support/axios";

class OrderStatus {

    static internal_order_statuses = null;

    static async listOrderStatuses() {
        return new Promise((resolve, reject) => {
            if (OrderStatus.internal_order_statuses) {
                resolve(OrderStatus.internal_order_statuses);
            } else {
                axios.get('/api/order-statuses', self.data)
                    .then((response) => {
                        OrderStatus.internal_order_statuses = response.data;

                        resolve(OrderStatus.internal_order_statuses);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            }
        });
    }

}


export { OrderStatus };
